<template>
  <v-card v-if="register || loadingSearch || error" outlined class="pa-2">
    <v-alert v-if="error" type="error" text class="mb-0">
      {{ error }}
    </v-alert>
    <v-skeleton-loader
      v-else-if="loadingSearch"
      type="paragraph"
    ></v-skeleton-loader>
    <template v-else-if="register.notFound">
      <v-icon color="error" large>mdi-account-off</v-icon>
      <p class="mb-0">Registro não encontrado</p>
    </template>
    <div v-else class="d-flex gap-2 align-center">
      <div>
        <v-img
          :src="register?.face"
          width="60"
          height="80"
          class="rounded"
        ></v-img>
      </div>
      <div>
        <span>Registro encontrado</span>
        <h4 class="mb-0">{{ register.name }}</h4>
      </div>
    </div>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import STORE from "@/services/store";

export default {
  props: {
    accessId: {
      type: String,
    },
  },
  data: () => ({
    loadingSearch: false,
    register: false,
    error: false,
    searchTimeout: null,
  }),
  methods: {
    async searchId() {
      try {
        if (!this.accessId) return;
        this.loadingSearch = true;
        this.error = false;

        const response = await STORE.desktopClient.searchUser(
          this.selectedStore.id,
          this.accessId
        );

        this.register = response.users.find(
          (user) => user.accessId === this.accessId
        ) || {
          notFound: true,
        };
      } catch (e) {
        this.error = "Não foi possível se comunicar com o dispositivo";
        this.loadingSearch = false;
      } finally {
        this.loadingSearch = false;
      }
    },
  },
  computed: {
    ...mapGetters("store", ["selectedStore"]),
  },
  watch: {
    accessId: {
      handler() {
        this.register = false;
        clearTimeout(this.searchTimeout);
        if (!this.accessId) return;
        this.loadingSearch = true;
        this.error = false;

        this.searchTimeout = setTimeout(() => {
          this.searchId();
        }, 500);
      },
    },
  },
  mounted() {
    this.searchId();
  },
};
</script>
